{
  "addAdvisor": "Legg til rådgjevar",
  "addBoardMember": "Legg til styremedlem",
  "addClusterManagement": "Legg til i ledelsen",
  "addContact": "Legg til kontakt",
  "addContacts": "Legg til kontakter",
  "addContingent": "Legg til kontingent",
  "addFocusArea": "Legg til fokusområde",
  "addHourRate": "Legg til timesats",
  "addInterestArea": "Legg til interesseområde",
  "addLead": "Legg til lead",
  "addLeaders": "Legg til leiing",
  "addMainGoal": "Legg til hovudmål",
  "addCustomer": "Legg til kunde",
  "addPartner": "Legg til samarbeidspartner",
  "addProjectCategory": "Legg til prosjektkategori",
  "addSelfEffort": "Legg til eigeninnsats",
  "approveSelfEffort": "Godkjenn eigeninnsats",
  "brregFetch": "Hent frå BrReg",
  "cancel": "Avbryt",
  "createNewApplication": "Opprett ny søknad",
  "createProject": "Opprett prosjekt",
  "deleteInterestArea": "Slett interesseområde",
  "deleteSelfEffort": "Slett eigeininnsats",
  "edit": "Redigere",
  "editFocusArea": "Endre fokusområde",
  "errorBoundaryResetButton": "Fjern feilmelding",
  "goToProjects": "Gå til prosjekter",
  "gotoResourceBase": "Gå tll ressursbasen",
  "import": "Import",
  "inviteToClusterPortal": "Inviter til portalen",
  "newEvent": "Nytt event",
  "newInterestArea": "Nytt interesseområde",
  "registerSelfEffort": "Registrer eigeninnsats",
  "removeAdvisor": "Fjern fra rådgivere",
  "removeBoardMember": "Fjern fra styret",
  "removeContact": "Fjern kontakt",
  "removeManagement": "Fjern fra ledelse",
  "removeMarkings": "Fjern markeringar",
  "removeParticipant": "Fjern deltakar",
  "save": "Lagre",
  "seeAllContacts": "Sjå alle kontakter",
  "seeAllMembers": "Sjå alle medlemmar",
  "sendReports": "Send inn rapportar",
  "unretire": "Meld inn",
  "clearFilter": "Nullstill filtre",
  "addOpportunity": "Legg til henvendelse",
  "importInvoice": "Importer faktura"
}
